import React, { useState } from 'react';
import useIsLoggedIn from 'tradera/hooks/use-is-loggedin';
import { PICKS_FOR_YOU } from '../content-types';
import { trackContainerClick } from '../analytics';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import ApplicationErrorBoundary from 'tradera/components/application-error-boundary/application-error-boundary';
import { ContentSwitch } from 'tradera/components/content-switch/content-switch';
import { RecommendationsCarousel } from './recommendations-carousel';
import { MoreResultsCard } from 'tradera/components/carousel/more-results-card/more-results-card';
import ALink from 'tradera/components/alink/alink';
import { StartPageSectionTitle } from '../start-page-section/start-page-section-title';

export const PICKS_FOR_YOU_PRIMARY_CAROUSEL_SLOT =
    'Infinite_scroll_recommendation_slot';

export const PicksForYou = () => {
    const isLoggedIn = useIsLoggedIn();
    const { t } = useTranslator();
    const [error, setError] = useState(false);
    const { toLocalizedUrl } = useUrlLocalizer();

    return error ? null : (
        <ApplicationErrorBoundary>
            <ContentSwitch
                id="picks-for-you"
                className="my-5"
                onSwitch={trackPicksForYouClick}
                options={[
                    {
                        key: 'selected',
                        node: (
                            <RecommendationsCarousel
                                slot={PICKS_FOR_YOU_PRIMARY_CAROUSEL_SLOT}
                                gtmLabel="Start Page Selected"
                                setError={() => setError(true)}
                                moreResultsCard={
                                    <MoreResultsCard
                                        data-load-more-recommendations
                                        href={toLocalizedUrl(
                                            '/ma/endless-recommendation/selected'
                                        )}
                                        onClick={() =>
                                            trackPicksForYouClick(
                                                'Picks for you button below'
                                            )
                                        }
                                        label={t(
                                            'startPage_recommendation_showMore'
                                        )}
                                    />
                                }
                            />
                        ),
                        label: t('startPage_recommendation_selected')
                    },
                    {
                        key: 'endingSoon',
                        node: (
                            <ApplicationErrorBoundary
                                fallback={<EndingSoonErrorMessage />}>
                                <RecommendationsCarousel
                                    slot="Last_chance_infinite_scroll"
                                    gtmLabel="Start Page Ending Soon"
                                    setError={() => setError(true)}
                                    moreResultsCard={
                                        <MoreResultsCard
                                            data-load-more-recommendations
                                            href={toLocalizedUrl(
                                                '/ma/endless-recommendation/endingSoon'
                                            )}
                                            onClick={() =>
                                                trackPicksForYouClick(
                                                    'Picks for you button below'
                                                )
                                            }
                                            label={t(
                                                'startPage_recommendation_showMore'
                                            )}
                                        />
                                    }
                                />
                            </ApplicationErrorBoundary>
                        ),
                        label: t('startPage_recommendation_endingSoon')
                    }
                ]}
                title={(selectedKey) => (
                    <StartPageSectionTitle
                        className="mb-1"
                        noMargins
                        href={toLocalizedUrl(
                            `/ma/endless-recommendation/${selectedKey}`
                        )}
                        inSpa={true}
                        onClick={() =>
                            trackPicksForYouClick('Picks for you title')
                        }>
                        {isLoggedIn
                            ? t('startPage_recommendation_justForYou')
                            : t('startPage_recommendation_trendingOnTradera')}
                    </StartPageSectionTitle>
                )}
            />
        </ApplicationErrorBoundary>
    );
};

const trackPicksForYouClick = (label) => {
    trackContainerClick(PICKS_FOR_YOU, label);
};

const EndingSoonErrorMessage = () => {
    const inSPA = true;
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <div className="col-12 text-center pt-2 pb-4">
            <p className="size-paris mb-3">
                <strong>
                    {t('startPage_recommendation_endingSoonHeading')}
                </strong>
            </p>
            <p className="pb-2 mb-4">
                {t('startPage_recommendation_endingSoonText')}
            </p>
            <div className="col-12 text-center">
                <ALink
                    useLink={inSPA}
                    data-recommendations-reload
                    role="button"
                    className="btn btn-primary btn-wide"
                    href={toLocalizedUrl('/campaign/sista-chansen')}>
                    {`${t('startPage_recommendation_lastChance')} ->`}
                </ALink>
            </div>
        </div>
    );
};
